/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_GreetingInputs */

const en_us2_today_greeting = /** @type {(inputs: Today_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hello`)
};

const pt_br2_today_greeting = /** @type {(inputs: Today_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá`)
};

const es_419_today_greeting = /** @type {(inputs: Today_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hola`)
};

const pt_pt2_today_greeting = /** @type {(inputs: Today_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá`)
};

const fr_fr2_today_greeting = /** @type {(inputs: Today_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonjour`)
};

const de_de2_today_greeting = /** @type {(inputs: Today_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo`)
};

const it_it2_today_greeting = /** @type {(inputs: Today_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciao`)
};

/**
* | output |
* | --- |
* | "Hello" |
*
* @param {Today_GreetingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_greeting = /** @type {((inputs?: Today_GreetingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_GreetingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_greeting(inputs)
	if (locale === "es-419") return es_419_today_greeting(inputs)
	if (locale === "pt-PT") return pt_pt2_today_greeting(inputs)
	if (locale === "fr-FR") return fr_fr2_today_greeting(inputs)
	if (locale === "de-DE") return de_de2_today_greeting(inputs)
	if (locale === "it-IT") return it_it2_today_greeting(inputs)
	return en_us2_today_greeting(inputs)
});
export { today_greeting as "today.greeting" }